import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {SharedModule} from '../../../../../../shared/shared.module';
import {DateComponent} from './date.component';


@NgModule({
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatInputModule,
    SharedModule
  ],
  declarations: [
    DateComponent
  ],
  entryComponents: [
    DateComponent
  ],
  exports: [
    DateComponent
  ]
})

export class DateModule {}
